import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const bscDmexJointMiningContract = require('./bscDmexJointMining.json')
const UpoolBscDmexJointMiningContract = require('./UpoolBscDmexJointMining.json')

let web3 = $web3js.getWeb3();
let contractAddress = $bizConfig.dmexJointMiningContractAddress;
let uContractAddress = $bizConfig.dmexJointMiningUpoolContractAddress;
let contractConst = {
    contract: web3 ? new web3.eth.Contract(bscDmexJointMiningContract.abi, contractAddress) : '',
}

let uContractConst = {
    contract: web3 ? new web3.eth.Contract(UpoolBscDmexJointMiningContract, uContractAddress) : '',
}


const getBscFilJointUAddress = () => {
        return contractAddress;
    }
const getBscuPoolJointUAddress = () => {
        return uContractAddress;
    }
    // const getContract = () => {
    //     return web3 ? new web3.eth.Contract(bscDmexJointMiningContract.abi, contractAddress) : '';
    // }
const getIfilJointUContract = () => {

    // let _contract = getContract();
    // alert(JSON.stringify(window.web3.currentProvider) + "===1==")
    // alert(JSON.stringify(_contract.currentProvider) + "===2==")
    // return _contract;
    return contractConst.contract;
}
const getIfilJointUpoolContract = () => {

    // let _contract = getContract();
    // alert(JSON.stringify(window.web3.currentProvider) + "===1==")
    // alert(JSON.stringify(_contract.currentProvider) + "===2==")
    // return _contract;
    return uContractConst.contract;
}

const bscJointUserDeposit = async([_pid, _amount, _contractAddress], options, callback) => {
    _pid = $web3js.stringToBytes32(_pid);
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);

    return $web3js.send(getIfilJointUContract().methods.userDeposit, [_pid, _amount], options, callback);
}

const bscJointUserDepositEstimateSend = async([_pid, _amount, _contractAddress], options) => {
    _pid = $web3js.stringToBytes32(_pid);
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);

    let gasPromise;
    gasPromise = $web3js.estimateSend(getIfilJointUContract().methods.userDeposit, [_pid, _amount], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return {
        gas,
        gasPrice,
        fee
    };
}


const bscUpoolJointUserDeposit = async([_pid, _amount, _contractAddress], options, callback) => {
    _pid = $web3js.stringToBytes32(_pid);
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);
    return $web3js.send(getIfilJointUpoolContract().methods.userDeposit, [_pid, _amount], options, callback);
}

const bscUpoolJointUserDepositEstimateSend = async([_pid, _amount, _contractAddress], options) => {
    _pid = $web3js.stringToBytes32(_pid);
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);
    let gasPromise;
    gasPromise = $web3js.estimateSend(getIfilJointUpoolContract().methods.userDeposit, [_pid, _amount], options);
    let gasPricePromise = $web3js.getGasPrice();
    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return {
        gas,
        gasPrice,
        fee
    };
}

const bscJointUserRedeem = async([_pid, _amount, _contractAddress, _principalContractAddress], options, callback) => {
    _pid = $web3js.stringToBytes32(_pid);
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);
    return $web3js.send(getIfilJointUContract().methods.userRedeem, [_pid, _amount], options, callback);
}

const bscJointUserRedeemEstimateSend = async([_pid, _amount, _contractAddress, _principalContractAddress], options) => {
    _pid = $web3js.stringToBytes32(_pid);
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);

    let gasPromise
    gasPromise = $web3js.estimateSend(getIfilJointUContract().methods.userRedeem, [_pid, _amount], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return {
        gas,
        gasPrice,
        fee
    };
}

const bscUpoolJointUserRedeem = async([_pid, _amount, _contractAddress, _principalContractAddress], options, callback) => {
    _pid = $web3js.stringToBytes32(_pid);
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);
    return $web3js.send(getIfilJointUpoolContract().methods.userRedeem, [_pid, _amount], options, callback);
}

const bscUpoolJointUserRedeemEstimateSend = async([_pid, _amount, _contractAddress, _principalContractAddress], options) => {
    _pid = $web3js.stringToBytes32(_pid);
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);

    let gasPromise
    gasPromise = $web3js.estimateSend(getIfilJointUpoolContract().methods.userRedeem, [_pid, _amount], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return {
        gas,
        gasPrice,
        fee
    };
}

const bscUpoolJointUserRedeemByLiq = async([_pid, _amount, _contractAddress, _principalContractAddress], options, callback) => {
    _pid = $web3js.stringToBytes32(_pid);
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);
    return $web3js.send(getIfilJointUpoolContract().methods.userRedeemByLiq, [_pid, _amount], options, callback);
}

const bscUpoolJointUserRedeemByLiqEstimateSend = async([_pid, _amount, _contractAddress, _principalContractAddress], options) => {
    _pid = $web3js.stringToBytes32(_pid);
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);

    let gasPromise
    gasPromise = $web3js.estimateSend(getIfilJointUpoolContract().methods.userRedeemByLiq, [_pid, _amount], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return {
        gas,
        gasPrice,
        fee
    };
}


const bscJointUserIncome = ([_pid, _principalContractAddress], options, callback) => {
    _pid = $web3js.stringToBytes32(_pid);
    return $web3js.send(getIfilJointUContract().methods.userIncome, [_pid], options, callback);
}

const bscUpoolJointUserIncome = ([_pid, _principalContractAddress], options, callback) => {
    _pid = $web3js.stringToBytes32(_pid);
    return $web3js.send(getIfilJointUpoolContract().methods.userIncome, [_pid], options, callback);
}

const bscJointUserIncomeEstimateSend = async([_pid, _principalContractAddress], options) => {
    _pid = $web3js.stringToBytes32(_pid);

    let gasPromise;
    gasPromise = $web3js.estimateSend(getIfilJointUContract().methods.userIncome, [_pid], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return {
        gas,
        gasPrice,
        fee
    };
}

const bscPoolJointUserIncomeEstimateSend = async([_pid, _principalContractAddress], options) => {
    _pid = $web3js.stringToBytes32(_pid);

    let gasPromise;
    gasPromise = $web3js.estimateSend(getIfilJointUpoolContract().methods.userIncome, [_pid], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return {
        gas,
        gasPrice,
        fee
    };
}

// const bscGetJointUPoolGlobalInfo = ([_pid], options) => {
//     return $web3js.call(getIfilJointUContract().methods.getGlobalInfo, [_pid], options, handlePoolGlobalInfo);
//   }

//   const handlePoolGlobalInfo = async (res) => {
//     // console.log("PoolGlobalInfo ", res)
//     let index = 0;
//     let ptoken = res[index++];
//     let afil = res[index++];
//     let dlp = res[index++];
//     // let dli = res[index++];
//     // let dpPrice = res[index++];
//     let userDeposits = res[index++];
//     let userGainPrincipals = res[index++];
//     let userGainBenefits = res[index++];
//     let plateformBenefits = res[index++];
//     let vendorGains = res[index++];
//     let vendorReleasePrincipals = res[index++];
//     let vendorReleaseBenefits = res[index++];
//     let state = res[index++];
//     let active = res[index++];

//     userDeposits = await $erc20.fromErc20Value(userDeposits, ptoken);
//     userGainPrincipals = await $erc20.fromErc20Value(userGainPrincipals, ptoken);
//     userGainBenefits = await $erc20.fromErc20Value(userGainBenefits, dli);
//     plateformBenefits = await $erc20.fromErc20Value(plateformBenefits, dli);
//     vendorGains = await $erc20.fromErc20Value(vendorGains, ptoken);
//     vendorReleasePrincipals = await $erc20.fromErc20Value(vendorReleasePrincipals, ptoken);
//     vendorReleaseBenefits = await $erc20.fromErc20Value(vendorReleaseBenefits, dli);

//     dpPrice = Vue.prototype.$numberUtils.movePointLeft(dpPrice, 18);

//     return {
//       ptoken,
//       afil,
//       dlp,
//     //   dli,
//     //   dpPrice,
//       userDeposits,
//       userGainPrincipals,
//       userGainBenefits,
//       plateformBenefits,
//       vendorGains,
//       vendorReleasePrincipals,
//       vendorReleaseBenefits,
//       state,
//       active,
//     }
//   }

const jointUVendorWithdraw = ([_pid], options) => {
    _pid = $web3js.stringToBytes32(_pid);
    return $web3js.send(getIfilJointUContract().methods.vendorWithdraw, [_pid], options);
}

const jointUVendorWithdrawEstimateSend = async([_pid], options) => {
    _pid = $web3js.stringToBytes32(_pid);

    let gasPromise = $web3js.estimateSend(getIfilJointUContract().methods.vendorWithdraw, [_pid], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return {
        gas,
        gasPrice,
        fee
    };
}

const getBscJointPoolInfo = ([_pid, ptoken], options) => {
    _pid = $web3js.stringToBytes32(_pid);
    return $web3js.call(getIfilJointUContract().methods.getMiningPoolInfo, [_pid], options, handlePoolInfo, [ptoken]);
}

const getBscUpoolJointPoolInfo = ([_pid, ptoken], options) => {
    _pid = $web3js.stringToBytes32(_pid);
    return $web3js.call(getIfilJointUpoolContract().methods.getMiningPoolInfo, [_pid], options, handlePoolInfo, [ptoken]);
}

const handlePoolInfo = async(res, ptoken) => {
    let index = 0;
    let totalPrincipalAmount = res[index++];
    let totalBenefitAmount = res[index++];
    let principalLiquidAmount = res[index++];
    let benefitLiquidAmount = res[index++];
    let principalExchangeAmount = res[index++];
    let benefitExchangeAmount = res[index++];

    totalPrincipalAmount = await $erc20.fromErc20Value(totalPrincipalAmount, ptoken);
    totalBenefitAmount = await $erc20.fromErc20Value(totalBenefitAmount, ptoken);
    principalLiquidAmount = await $erc20.fromErc20Value(principalLiquidAmount, ptoken);
    benefitLiquidAmount = await $erc20.fromErc20Value(benefitLiquidAmount, ptoken);
    principalExchangeAmount = await $erc20.fromErc20Value(principalExchangeAmount, ptoken);
    benefitExchangeAmount = await $erc20.fromErc20Value(benefitExchangeAmount, ptoken);

    return {
        totalPrincipalAmount,
        totalBenefitAmount,
        principalLiquidAmount,
        benefitLiquidAmount,
        principalExchangeAmount,
        benefitExchangeAmount,
    }
}

const getBscJointPoolGlobalInfo = ([_pid], options) => {

    return $web3js.call(getIfilJointUContract().methods.getGlobalInfo, [_pid], options, handlePoolGlobalInfo);
}

const getBscJointUpoolGlobalInfo = ([_pid], options) => {

    return $web3js.call(getIfilJointUpoolContract().methods.getGlobalInfo, [_pid], options, handlePoolGlobalInfo);
}


const handlePoolGlobalInfo = async(res) => {
    let index = 0;
    let ptoken = res[index++];
    let afil = res[index++];
    let dlp = res[index++];
    let userDeposits = res[index++];
    let userGainPrincipals = res[index++];
    let userGainBenefits = res[index++];
    let plateformBenefits = res[index++];
    let vendorGains = res[index++];
    let vendorReleasePrincipals = res[index++];
    let vendorReleaseBenefits = res[index++];
    let state = res[index++];
    let active = res[index++];

    userDeposits = await $erc20.fromErc20Value(userDeposits, ptoken);
    userGainPrincipals = await $erc20.fromErc20Value(userGainPrincipals, ptoken);
    userGainBenefits = await $erc20.fromErc20Value(userGainBenefits, ptoken);
    plateformBenefits = await $erc20.fromErc20Value(plateformBenefits, ptoken);
    vendorGains = await $erc20.fromErc20Value(vendorGains, ptoken);
    vendorReleasePrincipals = await $erc20.fromErc20Value(vendorReleasePrincipals, ptoken);
    vendorReleaseBenefits = await $erc20.fromErc20Value(vendorReleaseBenefits, ptoken);


    return {
        ptoken,
        afil,
        dlp,
        userDeposits,
        userGainPrincipals,
        userGainBenefits,
        plateformBenefits,
        vendorGains,
        vendorReleasePrincipals,
        vendorReleaseBenefits,
        state,
        active,
    }
}

const getBscUpoolliqConfig = (options) => {
    return $web3js.call(getIfilJointUpoolContract().methods.liqConfig,undefined,options, handlUpoolliqConfig);
}


const handlUpoolliqConfig = async(res) => {
    // let index = 0;
    // console.log(res)
    let payToken=res.payToken
    let convertPerShare = res.convertPerShare;
    let isStart = res.isStart
    // let afil = res[index++];
    // let dlp = res[index++];
    // let userDeposits = res[index++];
    // let userGainPrincipals = res[index++];
    // let userGainBenefits = res[index++];
    // let plateformBenefits = res[index++];
    // let vendorGains = res[index++];
    // let vendorReleasePrincipals = res[index++];
    // let vendorReleaseBenefits = res[index++];
    // let state = res[index++];
    // let active = res[index++];

    convertPerShare = await $erc20.fromErc20Value(convertPerShare, payToken);
    // userGainPrincipals = await $erc20.fromErc20Value(userGainPrincipals, ptoken);
    // userGainBenefits = await $erc20.fromErc20Value(userGainBenefits, ptoken);
    // plateformBenefits = await $erc20.fromErc20Value(plateformBenefits, ptoken);
    // vendorGains = await $erc20.fromErc20Value(vendorGains, ptoken);
    // vendorReleasePrincipals = await $erc20.fromErc20Value(vendorReleasePrincipals, ptoken);
    // vendorReleaseBenefits = await $erc20.fromErc20Value(vendorReleaseBenefits, ptoken);


    return {
        convertPerShare,
        isStart
        // afil,
        // dlp,
        // userDeposits,
        // userGainPrincipals,
        // userGainBenefits,
        // plateformBenefits,
        // vendorGains,
        // vendorReleasePrincipals,
        // vendorReleaseBenefits,
        // state,
        // active,
    }
}


const getBscJointUserIncome = ([_pid], options) => {
    return $web3js.call(getIfilJointUContract().methods.getUserIncome, [_pid], options, $web3js.fromWei);
}

const getBscUpoolJointUserIncome = ([_pid], options) => {
    return $web3js.call(getIfilJointUpoolContract().methods.getUserIncome, [_pid], options, $web3js.fromWei);
}


export default {
    getBscJointPoolGlobalInfo,
    getBscJointUpoolGlobalInfo,
    getBscJointUserIncome,
    getBscUpoolJointUserIncome,
    getBscJointPoolInfo,
    getBscUpoolJointPoolInfo,
    getBscFilJointUAddress,
    getBscuPoolJointUAddress,
    bscJointUserDeposit,
    bscUpoolJointUserDeposit,
    bscJointUserDepositEstimateSend,
    bscUpoolJointUserDepositEstimateSend,
    bscJointUserRedeem,
    bscUpoolJointUserRedeem,
    bscJointUserRedeemEstimateSend,
    bscUpoolJointUserRedeemEstimateSend,
    bscJointUserIncome,
    bscUpoolJointUserIncome,
    bscJointUserIncomeEstimateSend,
    bscPoolJointUserIncomeEstimateSend,
    getBscUpoolliqConfig,
    bscUpoolJointUserRedeemByLiq,
    bscUpoolJointUserRedeemByLiqEstimateSend

}


// WEBPACK FOOTER //
// ./src/lib/contract/bscDmexJointMining/index.js